import React from 'react';

export interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'warning' | 'error' | 'info';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  size = 'sm',
  className = '',
}) => {
  const baseClasses = 'inline-flex items-center rounded-full font-medium';

  const variantClasses = {
    default: 'bg-badge-default-background text-neutral-base',
    success: 'bg-badge-good-background text-positive-base',
    warning: 'bg-badge-warning-background text-severity-medium-base',
    error: 'bg-badge-bad-background text-negative-base',
    info: 'bg-badge-info-background text-severity-informational-base',
  };

  const sizeClasses = {
    sm: 'px-sm py-xs text-xs',
    md: 'px-md py-xs text-sm',
    lg: 'px-lg py-sm text-base',
  };

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return <span className={classes}>{children}</span>;
};

export default Badge;
